import { CompassCardUI } from '@scale/compass-ui/types';
import {
  SWEAP_PASS_AT_K,
  SweapPassAtKCardShared,
  type SweapPassAtKContext,
  type SweapPassAtKSchemaType,
} from '@scale/genai-compass-shared/cards/sweap_pass_at_k';
import SweapPassAtKCardComponent from './SweapPassAtKCardComponent';
import { faRobot } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: SweapPassAtKContext = {
  cardType: SWEAP_PASS_AT_K,
  k: 3,
  modelConfig: {
    id: 'endpoint_AnthropicStrategy_1',
    url: 'https://api.anthropic.com/v1/messages',
    params: {
      model: 'claude-opus-4-5',
    },
  },
  configS3Uri: 's3://scale-dev/model-eval/auto-evaluation/swe-agent/config/tool_use.yaml',
};

export const SweapPassAtKCardInfo: CompassCardUI<SweapPassAtKSchemaType> = {
  ...SweapPassAtKCardShared,
  title: 'SWEAP Pass@K',
  icon: 'robot',
  toolTip: 'Run Auto-Evaluation for SWEAP and compute Pass@K metrics',
  defaultContext,
  legacyComponent: SweapPassAtKCardComponent,
  button: {
    icon: faRobot,
  },
};
